import Vue from 'vue';
export const EventCoupon = new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/couponredeem/coupon-event-bus.js